import React from "react";
import { Box, Typography } from "@mui/material";
import BaptizeAmericaLogo from "../assets/baptize-america-header.svg";
import BaptizeCalfiorniaLogo from "../assets/baptize-california-header.svg";

const TitleBox = ({
  subtitle,
  logoType = "america",
}: {
  subtitle?: string;
  logoType?: string;
}) => {
  return (
    <div>
      <Box
        component="img"
        sx={{
          width: 225,
          height: 60,
        }}
        alt={
          logoType === "california" ? "Baptize California" : "Baptize America"
        }
        src={
          logoType === "california" ? BaptizeCalfiorniaLogo : BaptizeAmericaLogo
        }
      />
      {subtitle ? (
        <Typography
          variant="subtitle1"
          sx={{ mt: 2, mb: 2, textAlign: "center" }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </div>
  );
};

export default TitleBox;
